import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { AppState } from '../../app.state';
import { Route, RoutingHelperService } from '../services/routing-helper.service';

/**
 * Exige os dados do titular em Dependentes e Contrato.
 *
 * O state não é persistido: um recarregamento nessas etapas zera o titular,
 * e antes o `subscriptionGuard` barrava esse caso por tabela. Sem ele, o
 * Contrato montava o pedido de emissão com o titular vazio e quebrava.
 */
export const holderGuard: CanActivateFn = () => {
  const store = inject(Store);
  const router = inject(Router);
  const routingService = inject(RoutingHelperService);

  const holder = store.selectSnapshot(AppState.getHolder);

  if (holder && holder.cpf && holder.birthday) {
    return true;
  }

  return router.createUrlTree([routingService.getRelativePath(Route.Data.path)]);
};
